import React, { Suspense, lazy } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { UploadPage } from "../pages/upload/UploadPage";
import { getCurrentSession, isAdmin } from "./../../commons/auth";

// lazy loading of "other" pages (code splitting)
const NotFoundPage = lazy(() =>
  import("../pages/notfound/NotFoundPage").then(({ NotFoundPage }) => ({
    default: NotFoundPage,
  }))
);
const AdminPage = lazy(() =>
  import("../pages/admin/AdminPage").then(({ AdminPage }) => ({
    default: AdminPage,
  }))
);
const LoginPage = lazy(() =>
  import("../pages/login/LoginPage").then(({ LoginPage }) => ({
    default: LoginPage,
  }))
);
const LogoutPage = lazy(() =>
  import("../pages/logout/LogoutPage").then(({ LogoutPage }) => ({
    default: LogoutPage,
  }))
);

/**
 * The app routers.
 *
 * NOTE:
 *  The '/admin' route uses the render function (instead of children
 *  components). This allows/causes the route to be re-rendered
 *  (because its an anonymous function) and update the current session
 *  status. It would not re-render when used with children components.
 */

export const Routes: React.FC = () => {
  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact path="/" component={UploadPage} />
          <Route
            exact
            path="/admin"
            render={() =>
              isAdmin(getCurrentSession()) ? (
                <AdminPage />
              ) : (
                <Redirect to="/login?redirect=/admin" />
              )
            }
          />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/logout" component={LogoutPage} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Suspense>
    </>
  );
};
